import { withOneTrust } from '@segment/analytics-consent-wrapper-onetrust';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { userStore } from '$lib/stores/userStore';
import { get } from 'svelte/store';

export const analytics = new AnalyticsBrowser();

export function initSegment() {
  const segmentElement: HTMLElement | null = document.querySelector('meta[name=SEGMENT_TOKEN]');

  if (segmentElement instanceof HTMLMetaElement) {
    const segmentToken = segmentElement.content;
    withOneTrust(analytics).load({ writeKey: segmentToken });
  }
}

export function checkoutStarted() {
  const subscriptionPlan: HTMLInputElement | null = document.querySelector(
    "input[name='radio']:checked",
  );
  const discount: HTMLInputElement | null = document.querySelector('span[data-discount]');
  const defaultPlan: HTMLInputElement | null = document.querySelectorAll("input[name='radio']")[0];
  const promoCode: HTMLInputElement | null = document.querySelector('span[data-coupon]');
  return {
    subscription_plan:
      promoCode !== null
        ? `${promoCode?.getAttribute('data-coupon')}-${subscriptionPlan?.getAttribute('data-plan')}`
        : subscriptionPlan?.getAttribute('data-plan'),
    subscription_cost: subscriptionPlan?.getAttribute('data-price'),
    currency: subscriptionPlan?.getAttribute('data-currency'),
    subscription_discount:
      discount !== null
        ? discount?.getAttribute('data-discount')?.replace(' off', '')
        : 'invalid discount',
    exchange_rate: 1.0,
    plan_is_default: subscriptionPlan === defaultPlan,
  };
}

function cartPayload() {
  const subscriptionPlan: HTMLInputElement | null = document.querySelector(
    "input[name='radio']:checked",
  );
  const discount: HTMLInputElement | null = document.querySelector('span[data-discount]');
  const defaultPlan: HTMLInputElement | null = document.querySelectorAll("input[name='radio']")[0];
  const promoCode: HTMLInputElement | null = document.querySelector('span[data-coupon]');
  return {
    subscription_plan:
      promoCode !== null
        ? `${promoCode?.getAttribute('data-coupon')}-${subscriptionPlan?.getAttribute('data-plan')}`
        : subscriptionPlan?.getAttribute('data-plan'),
    subscription_cost: subscriptionPlan?.getAttribute('data-price'),
    currency: subscriptionPlan?.getAttribute('data-currency'),
    subscription_discount:
      discount !== null
        ? discount?.getAttribute('data-discount')?.replace(' off', '')
        : 'invalid discount',
    exchange_rate: 1.0,
    plan_is_default: subscriptionPlan === defaultPlan,
  };
}

export function trackCartUpdated() {
  analytics.track('Cart Updated', cartPayload());
}

export function trackIdentifyUser() {
  const user = get(userStore).user;
  const canonicalId = user?.user_metadata?.user_canonical_id;
  if (!canonicalId) {
    return false;
  }
  analytics.identify(canonicalId, {
    first_name: user?.given_name,
    last_name: user?.family_name,
    birthday: user?.user_metadata?.user_dob,
    email: user?.email,
    created_at: user?.user_metadata?.user_created_at,
  });
}

export function trackUserOnboarded() {
  const user = get(userStore).user;
  const canonicalId = user?.user_metadata?.user_canonical_id;
  if (!canonicalId) {
    return false;
  }
  const subscriptionPlan: HTMLInputElement | null = document.querySelector(
    "input[name='radio']:checked",
  );
  const defaultPlan: HTMLInputElement | null = document.querySelectorAll("input[name='radio']")[0];
  const discount: HTMLInputElement | null = document.querySelector('span[data-discount]');
  const promoCode: HTMLInputElement | null = document.querySelector('span[data-coupon]');
  analytics.track('User Onboarded', {
    subscription_plan:
      promoCode !== null
        ? `${promoCode?.getAttribute('data-coupon')}-${subscriptionPlan?.getAttribute('data-plan')}`
        : subscriptionPlan?.getAttribute('data-plan'),
    subscription_cost: subscriptionPlan?.getAttribute('data-price'),
    currency: subscriptionPlan?.getAttribute('data-currency'),
    subscription_discount:
      discount !== null
        ? discount?.getAttribute('data-discount')?.replace(' off', '')
        : 'invalid discount',
    exchange_rate: 1.0,
    plan_is_default: subscriptionPlan === defaultPlan,
    promo_code: promoCode !== null ? promoCode?.getAttribute('data-coupon') : 'invalid promo code',
    login_method: user?.user_metadata?.user_login_method,
  });
}

function paymentEntered() {
  const subscriptionPlan: HTMLInputElement | null = document.querySelector(
    "input[name='radio']:checked",
  );
  const defaultPlan: HTMLInputElement | null = document.querySelectorAll("input[name='radio']")[0];
  const discount: HTMLInputElement | null = document.querySelector('span[data-discount]');
  const promoCode: HTMLInputElement | null = document.querySelector('span[data-coupon]');
  const linkPayment =
    document?.querySelector('#Field-linkEmailInput') ||
    document?.querySelector('#Field-emailInput');

  return {
    subscription_plan:
      promoCode !== null
        ? `${promoCode?.getAttribute('data-coupon')}-${subscriptionPlan?.getAttribute('data-plan')}`
        : subscriptionPlan?.getAttribute('data-plan'),
    subscription_cost: subscriptionPlan?.getAttribute('data-price'),
    currency: subscriptionPlan?.getAttribute('data-currency'),
    subscription_discount:
      discount !== null
        ? discount?.getAttribute('data-discount')?.replace(' off', '')
        : 'invalid discount',
    exchange_rate: 1.0,
    plan_is_default: subscriptionPlan === defaultPlan,
    promo_code: promoCode !== null ? promoCode?.getAttribute('data-coupon') : 'invalid promo code',
    payment_method: linkPayment ? 'Link' : 'Credit Card',
  };
}

export function trackPaymentEntered() {
  const user = get(userStore).user;
  const canonicalId = user?.user_metadata?.user_canonical_id;
  if (!canonicalId) {
    return false;
  }
  analytics.track('Payment Info Entered', paymentEntered());
}
